import React from 'react';
import { NavLink } from 'react-router-dom';

import {
  TENDER_OVERVIEW_URL,
  TENDERS_LIST_URL,
  CREATE_TENDER_URL,
  TENDER_SUBSCRIBE_URL
} from 'global-constants';

import { substituteUrl } from 'shared/utils/substituteUrl';
import ExternalLink from 'shared/components/ExternalLink';
import VisibleIfUserIsLogged from 'shared/components/VisibleIfUserIsLogged';

import styles from './styles.module.scss';

const TendersDropdown = props => {
  return (
    <div className={styles.tendersDropdownWrapper}>
      <span className={styles.title}>For Buyers</span>
      <NavLink
        id="navigation-project-overview"
        className={styles.item}
        to={TENDER_OVERVIEW_URL}
        activeClassName={styles.selectedItem}>
        Overview
      </NavLink>
      <NavLink
        id="navigation-create-project"
        className={styles.item}
        to={substituteUrl(CREATE_TENDER_URL, { activeTab: 'create' })}
        activeClassName={styles.selectedItem}>
        Create a Project
      </NavLink>
      <VisibleIfUserIsLogged>
        <NavLink
          id="navigation-my-projects"
          className={styles.item}
          to={substituteUrl(CREATE_TENDER_URL, { activeTab: 'open' })}
          activeClassName={styles.selectedItem}>
          My Projects
        </NavLink>
      </VisibleIfUserIsLogged>

      <span className={styles.title}>For Sellers</span>
      <NavLink
        id="navigation-available-projects"
        className={styles.item}
        to={substituteUrl(TENDERS_LIST_URL, { activeTab: 'open' })}
        activeClassName={styles.selectedItem}>
        Available Projects
      </NavLink>
      <ExternalLink
        id="navigation-tender-subscribe"
        className={styles.item}
        href={TENDER_SUBSCRIBE_URL}>
        Subscribe
      </ExternalLink>
      <VisibleIfUserIsLogged>
        <NavLink
          id="navigation-my-submissions"
          className={styles.item}
          to={substituteUrl(TENDERS_LIST_URL, { activeTab: 'my-submissions' })}
          activeClassName={styles.selectedItem}>
          My Submissions
        </NavLink>
      </VisibleIfUserIsLogged>
    </div>
  );
};

export default TendersDropdown;
